
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySleetShowersNightColour as ObiHeavySleetShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-sleet-showers-night-colour.js';
 
 
 

 
 export const ObiHeavySleetShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-heavy-sleet-showers-night-colour',
   elementClass: ObiHeavySleetShowersNightColourElement,
   events: {
     
   }
  });
 
 